var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-912 -1002) translate(912 1002)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M16.03 32.624c.716 0 1.253-.181 1.611-.545.358-.363.537-.898.537-1.603V9.382c0-.727-.179-1.264-.537-1.611-.358-.347-.895-.521-1.611-.521h-3.548c-.706 0-1.24.182-1.603.545-.364.364-.546.893-.546 1.587v21.094c0 .705.18 1.24.537 1.603.359.364.896.545 1.612.545h3.548zm11.475 0c.705 0 1.237-.181 1.595-.545.358-.363.537-.898.537-1.603V9.382c0-.727-.18-1.264-.537-1.611-.358-.347-.89-.521-1.595-.521H23.94c-.716 0-1.253.182-1.611.545-.358.364-.537.893-.537 1.587v21.094c0 .705.179 1.24.537 1.603.358.364.895.545 1.611.545h3.565z",
    transform: "translate(-912 -1002) translate(912 1002)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.2afc039e.svg";
export { ForwardRef as ReactComponent };